import { useNavigate } from "react-router-dom";
import { useStateContext } from "../Contexts/ContextProvider";

const Card = ({ icon, title, value, coll = "primary", users = [] }) => {
  const navigate = useNavigate();
  const { setData } = useStateContext();

  const handleShow = () => {
    setData(users);
    navigate("/dashboard/reports");
  };

  // Soft color map for a modern look
  const colorMap = {
    dark: { bg: "bg-dark", text: "text-white", soft: "bg-dark bg-opacity-10 text-dark" },
    warning: { bg: "bg-warning", text: "text-dark", soft: "bg-warning bg-opacity-10 text-warning" },
    success: { bg: "bg-success", text: "text-white", soft: "bg-success bg-opacity-10 text-success" },
    info: { bg: "bg-info", text: "text-white", soft: "bg-info bg-opacity-10 text-info" },
    primary: { bg: "bg-primary", text: "text-white", soft: "bg-primary bg-opacity-10 text-primary" },
    danger: { bg: "bg-danger", text: "text-white", soft: "bg-danger bg-opacity-10 text-danger" },
  };

  const colors = colorMap[coll] || colorMap.primary;

  return (
    <div className="card border-0 shadow-sm h-100 rounded-3 overflow-hidden">
      <div className="card-body d-flex flex-column p-4">
        {/* Header row */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div
            className={`rounded-3 d-flex align-items-center justify-content-center ${colors.soft}`}
            style={{ width: 48, height: 48 }}
          >
            <i className="material-icons" style={{ fontSize: 24 }}>
              {icon}
            </i>
          </div>
          <span className="badge rounded-pill bg-light text-muted small">
            View details
          </span>
        </div>

        {/* Title */}
        <p className="text-muted text-uppercase small fw-semibold mb-1 letter-spacing">
          {title}
        </p>

        {/* Value */}
        <h3 className="fw-bold mb-4">{value}</h3>

        {/* Action */}
        <div className="mt-auto">
          <button
            className={`btn ${colors.bg} ${colors.text} w-100 rounded-pill fw-medium`}
            onClick={handleShow}
          >
            More details
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;